import { FC , useState } from "react";
import { formatDateText, getCurrentYear, isYearEnabled } from "../../../helpers/datetime";

const CalendarYearWidget: FC<({
    fromDate: string,
    onSelectYear: (date: string) => void,
})>
    = ({
        fromDate,
        onSelectYear,
    }) => {

        let yearsList = Array.from({ length: getCurrentYear() - 2022 + 20 }, (_, i) => 2022 + i);


        const [selectedYear, setSelectedYear] = useState(getCurrentYear(fromDate));


        return (
            <div className="w-[70%] mx-auto">
                <div className={`grid grid-cols-6 gap-2 mt-2 text-center fs-14`}>
                    {yearsList.map((year, i) => (
                        <div
                            key={i}
                            className={`flex items-center justify-center m-2 
                                ${isYearEnabled(year - 1) ? 'cursor-pointer' : 'color-sub-text'}  
                            ${(year == selectedYear) ? 'rounded-lg bg-primary p-2 text-white' : ''}`}
                            onClick={() => {
                                if (isYearEnabled(year - 1)) {
                                    setSelectedYear(year);
                                     const date = new Date(year, 0, 1); 
                                    onSelectYear(formatDateText(date));
                                }
                            }}
                        >
                            {year}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

export default CalendarYearWidget;